// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox-module--wrapper--BHnL5","bounce":"Checkbox-module--bounce--3y_ev"};